import { Loader2 } from "lucide-react";
import { STATO_STYLE, isProcessing } from "../lib/constants";

export const StatusBadge = ({ stato, className = "" }) => {
  const s = STATO_STYLE[stato] || STATO_STYLE.CARICATO;
  return (
    <span
      data-testid={`status-badge-${stato}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold font-mono tracking-wide ${className}`}
      style={{ background: s.bg, color: s.text }}
    >
      {isProcessing(stato) ? (
        <Loader2 className="h-3 w-3 spin-slow" />
      ) : (
        <span className="h-1.5 w-1.5 rounded-full" style={{ background: s.text }} />
      )}
      {s.label}
    </span>
  );
};
